module.exports = __webpack_public_path__ + "img/logo-hen.153bdd61.png";